import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-escalation',
  templateUrl: './escalation.component.html',
  styleUrls: ['./escalation.component.css']
})
export class EscalationComponent implements OnInit, OnDestroy {

  displayed = true;
  name: string;
  dropdown: string;
  clientId: number;

  add = false;
  del = false;
  edit = false;
  view = false;

  displayData: any;

  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  types = [];
  private notifier: NotifierService;
  typeSelected: number;
  isDropdown: boolean;
  typeChecked: number;
  type: string;
  ttypes = [];
  categories = [];
  defaultValue: string;
  categorySelected: number;
  private category: any;
  groups = [];
  groupSelected: number;
  private groupName: string;
  escalated: any;
  priorities = [];
  prioritySelected: number;
  priority: any;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  urgencySelected: any;
  urgencys: any;
  desc: string;


  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            // if (confirm('Are you sure?')) {
            //   item.user_id = this.messageService.getUserId();
            //   this._rest.updateBusinessPriority(item).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //       // console.log('data--Done');
            //       this.notifier.notify('success', 'Updated successfully');
            //     } else {
            //       // console.log('data--Not---Done');
            //       this.notifier.notify('error', this.respObject.errorMessage);
            //     }
            //   }, (err) => {
            //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
            //   });
            // }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              this._rest.deleteTicketExtandMstTbl({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
      }
    });
  }


  ngOnInit() {
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Escalation',
      openModalButton: 'Add Escalation',
      searchModalButton: 'Search',
      breadcrumb: 'Escalation',
      folderName: 'All Escalation',
      tabName: 'Escalation'
    };
    this.types = [{id: 1, name: 'text'}, {id: 2, name: 'numeric'}, {id: 3, name: 'dropdown'}];

    this.typeSelected = 1;

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', minWidth: 30, sortable: true, filterable: true},
      {
        id: 'esc', name: 'Escalation', field: 'escalation', minWidth: 150, sortable: true, filterable: true, cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'priority', name: 'priority', field: 'priority', sortable: true, filterable: true
      }, {
        id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
      },
      {
        id: 'ttype', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
      },
      {
        id: 'Group', name: 'Group', field: 'sgroup', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    this.messageService.setGridWidth(1000);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }

    this.searchData.valueChanges.subscribe(
      name => {
          this.isLoading = true;
          this._rest.searchAllBusinessUrgency(name, this.clientId).subscribe((res1) => {
              this.respObject = res1;
              this.isLoading = false;
              if (this.respObject.success) {
                  this.urgencys = this.respObject.details;
              } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
              }
          }, (err) => {
              this.isLoading = false;
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
      });
  }

  onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
            this.typeChecked = this.respObject.details[0].id;
            this.type = this.respObject.details[0].name;
            this.ttypes = this.respObject.details;
            this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.typeChecked).subscribe((res2) => {
              this.respObject = res2;
              if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
              } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
              }
            }, (err) => {
              this.isError = true;
              this.errorMessage = this.messageService.SERVER_ERROR;
            });
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        // this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   if (this.respObject.success) {
        //     this.isError = false;
        //     this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
        //     this.groups = this.respObject.details;
        //     this.groupSelected = 0;
        //   } else {
        //     this.isError = true;
        //     this.errorMessage = this.respObject.errorMessage;
        //   }
        // }, (err) => {
        //   this.isError = true;
        //   this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        this._rest.getFirstLevelCategory(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            // console.log(this.respObject);
            this.respObject.details.unshift({id: 0, name: 'Select Category'});
            this.categories = this.respObject.details;
            this.categorySelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.groupSelected = 0;
      this.categorySelected = 0;
      this.typeSelected = 1;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }
  searchModal(scarch_content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.groupSelected = 0;
      this.categorySelected = 0;
      this.typeSelected = 1;
      this.desc ='';
      this.urgencySelected ='';
      this.modalService.open(scarch_content).result.then((result) => {
      }, (reason) => {

      });
    }
  }
getUserDetails() {
    for (let i = 0; i < this.urgencys.length; i++) {
        if (this.urgencys[i].name === this.urgencySelected) {
         
            this.desc = this.urgencys[i].des;
        }
    }
}
search() {
  const data = [];
  for (let i = 0; i < this.urgencys.length; i++) {
      if (this.urgencys[i].name === this.urgencySelected) {
        data.push(this.urgencys[i]);
      }
  }
  this.page_no = 1;
  this.messageService.setTotalData(data.length);
  this.messageService.setGridData(data);
}
  save() {
    const data = {
      clientId: this.clientId,
      ticketType: this.typeChecked, busi_priority_id: this.prioritySelected, supportGroupLevelId: this.groupSelected,
      escalation_dtls: this.escalated, category_id: this.categorySelected,
      createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertTicketEscalationDtlsSupportGrpWise(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          // console.log(this.respObject)
          const id = this.respObject.details;
          this.messageService.setRow({
            id: id,
            escalation: this.escalated,
            priority: this.priority,
            ticketType: this.typeChecked,
            sgroup: this.groupName,
            category: this.category
          });
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.escalated = '';
          this.groupSelected = 0;
          this.categorySelected = 0;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this._rest.getTicketEscalationDtlsSupportGrpWise(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

  onButtonChange(value) {
    this.typeChecked = value.value;
  }

  onCategoryChange(selectedIndex) {
    this.category = this.categories[selectedIndex].name;
    this._rest.getSupportGroupByCategory(this.clientId, this.categorySelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
        this.groups = this.respObject.details;
        this.groupSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onPriorityChange(selectedIndex) {
    this.priority = this.priorities[selectedIndex].name;
  }

  onGroupChange(selectedIndex: any) {
    this.groupName = this.groups[selectedIndex].name;
  }
}
